import { render } from "./BalanceSheet.vue?vue&type=template&id=253422b8&scoped=true"
import script from "./BalanceSheet.vue?vue&type=script&lang=js"
export * from "./BalanceSheet.vue?vue&type=script&lang=js"

import "./BalanceSheet.vue?vue&type=style&index=0&id=253422b8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\abbas\\Desktop\\kswc\\kswc_dashboard-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-253422b8"]])

export default __exports__